import React from 'react';
import ReactLoading from "react-loading";
import "./LoadingPanel.css";

export const LoadingPanel = () =>
(
    
     
    <ReactLoading className="react-loading" type="spin" color="#2098ab" />
   
);

export default LoadingPanel;
